import { Account } from "@idha/idha-types";
import { LoggedUser } from "../../../redux/store";
import packingAccessPermissions, { PackingAccessPermissions, PackingPermissionsPipeData } from "./packing-access-rules";
import tagsAccessPermissions, { TagsAccessPermissions, TagsPermissionsPipeData } from "./tags-access-rules";
import generalAccessPermissions, { GeneralAccessPermissions, GeneralPermissionsPipeData } from "./general-access-rules";
import accountsAccessPermission, { AccountsAccessPermissions, AccountsPermissionsPipeData } from "./accounts-access-rules";
import areaSchedulingAccessPermissions, { AreaSchedulingAccessPermissions, AreaSchedulingPermissionsPipeData } from "./area-scheduling-access-rules";
import orderAccessPermissions, { OrderAccessPermissions, OrderPermissionsPipeData } from "./order-access-rules";


export class AccessPermissions {
    general: GeneralAccessPermissions
    accounts: AccountsAccessPermissions
    order: OrderAccessPermissions
    packing: PackingAccessPermissions
    tags: TagsAccessPermissions
    areaScheduling: AreaSchedulingAccessPermissions
}

export function getAccessPermissions(loggedUser: LoggedUser, account?: Account): AccessPermissions {
    if (!loggedUser) return;

    return {
        accounts: accountsAccessPermission(new AccountsPermissionsPipeData(loggedUser, account)),
        packing: packingAccessPermissions(new PackingPermissionsPipeData(loggedUser, account)),
        order: orderAccessPermissions(new OrderPermissionsPipeData(loggedUser, account)),
        general: generalAccessPermissions(new GeneralPermissionsPipeData(loggedUser)),
        tags: tagsAccessPermissions(new TagsPermissionsPipeData(loggedUser)),
        areaScheduling: areaSchedulingAccessPermissions(new AreaSchedulingPermissionsPipeData(loggedUser, account))
    }

}